import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Button, CircularProgress } from '@mui/material';
const ContainedButton = forwardRef((props, ref) => {
    const { color = 'primary', disabled, loading } = props;
    const buttonProps = Object.assign({}, props);
    delete buttonProps['loading'];
    const endIcon = useMemo(() => {
        if (props.loading && !props.endIcon) {
            return _jsx(CircularProgress, { size: "1rem" });
        }
        else if (!props.loading && props.endIcon) {
            return props.endIcon;
        }
        else {
            return '';
        }
    }, [props.endIcon, props.loading]);
    return (_jsx(Button, Object.assign({ ref: ref, variant: "contained" }, buttonProps, { color: color, disabled: disabled || loading, endIcon: endIcon })));
});
export default ContainedButton;
